// import useNotificationHandler from "hooks/useNotificationHandler";
import { QUERY_KEYS } from "library/shared";
import { ICurrencyRates } from "library/types";
import { useQuery } from "react-query";
import api from "service/api";


const getRates = async () => {
  const response = await api.get(
    `/rates`
  );
  return response.data?.rates as ICurrencyRates['rates'];
};



export function useGetCurrencyRates() {
      // const { handleAddAxiosErrorNotification } = useNotificationHandler();
    
  return useQuery<ICurrencyRates['rates'], Error>(
    [QUERY_KEYS.currencyRates],
    getRates,
    {
      enabled: true,
      onError: (error: any) => {
        // handleAddAxiosErrorNotification(error);

      },
    }
  );
}

